import type { ReactNode } from 'react'
import type { Capability } from '@one-deployment/shared'
import { useMe } from '@/features/auth/useMe'
import { can } from '@/lib/can'

/**
 * Hides what the person can never do on this project (03 §7). Actions blocked
 * by state rather than role are disabled with a reason by the caller instead.
 */
export function RoleGate({ action, project, children, fallback = null }: { action: Capability; project?: string | null; children: ReactNode; fallback?: ReactNode }) {
  const me = useMe().data
  return <>{can(me, action, project) ? children : fallback}</>
}

export function useCan(action: Capability, project?: string | null): boolean {
  const me = useMe().data
  return can(me, action, project)
}
